const WORKLET_URL = "/engine-worklet.js";
export async function createEngineNode(ctx, wasmModule, glueUrl) {
    if (glueUrl && wasmModule) {
        try {
            const glueResolved = new URL(glueUrl, location.origin).href;
            await ctx.audioWorklet.addModule(glueResolved);
            console.info("[worklet-host] emscripten glue added to worklet scope", glueResolved);
        }
        catch (err) {
            console.warn("[worklet-host] failed to add glue as worklet module; " +
                "worklet will use JS DSP fallback", err);
        }
    }
    const url = new URL(WORKLET_URL, location.origin).href;
    try {
        await ctx.audioWorklet.addModule(url);
    }
    catch (err) {
        console.error("[worklet-host] addModule failed for", url, err);
        throw err;
    }
    try {
        const node = new AudioWorkletNode(ctx, "agility-engine", {
            numberOfInputs: 1,
            numberOfOutputs: 1,
            outputChannelCount: [1],
            processorOptions: { hasWasm: !!wasmModule },
        });
        return node;
    }
    catch (err) {
        console.error("[worklet-host] AudioWorkletNode construction failed. This " +
            "usually means the worklet module threw during evaluation " +
            "(before registerProcessor ran). Check the worklet global " +
            "scope for missing browser globals (e.g. URL).", err);
        throw err;
    }
}
